import { Routes } from '@angular/router';
import { AutoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';

import { ErrorPage } from '@pages/error.page';
import { InfoPage } from '@pages/info.page';
import { OIDCCallbackPage } from '@pages/oidc-callback.page';
import { QuotingPage } from '@pages/quoting.page';
import { UnauthorizedPage } from '@pages/unauthorized.page';

export const routesConfig: Routes = [
  { path: 'callback', component: OIDCCallbackPage },
  { path: 'info', component: InfoPage },
  { path: 'quoting', component: QuotingPage, canActivate: [AutoLoginPartialRoutesGuard] },
  { path: 'unauthorized', component: UnauthorizedPage },
  { path: 'error', component: ErrorPage },
  { path: '', redirectTo: 'info', pathMatch: 'full' },
  { path: '**', redirectTo: 'error' },
];
